import React from "react"
import PropTypes from "prop-types"
import Styles from "./checklist-item.module.scss"

const ChecklistItem = ({ title }) => {
  return (
    <p className={Styles.checklistItem}>
      <div className={Styles.checklistItem__icon}>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 4.5L6.75 12.75L3 9" stroke="#00DDF1" stroke-width="2" stroke-linecap="square" />
        </svg>
      </div>
      <span className={Styles.checklistItem__text}>{title}</span>
    </p>
  )
}

ChecklistItem.propTypes = {
  title: PropTypes.string,
}

ChecklistItem.defaultProps = {
  title: "",
}

export default ChecklistItem
